import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import cn from 'classnames';

function Badge({ className, onClick, color, size, checked }) {
  return (
    <div
      onClick={onClick}
      className={cn('badge', className, {
        [`badge--${size}`]: size,
        [`badge--${color}`]: color,
      })}
    >
      {checked && <CheckOutlined />}
    </div>
  );
}

export default Badge;
